module.exports = __webpack_public_path__ + "src/assets/img/3.77d150ed.png";